import { courses } from '@/mocks/courses';
import { SITE } from '@/constants';

type Course = (typeof courses)[number];

function CourseCard({ course }: { course: Course }) {
  return (
    <article className="group bg-neutral-900 border border-white/10 flex flex-col reveal">
      <div className="relative overflow-hidden">
        <img
          src={course.image}
          alt={`${course.name} — curso de render arquitectónico en San Luis Potosí`}
          title={`${course.name} · Cursos de render con IA`}
          className="w-full aspect-[16/9] object-cover object-top opacity-90 transition-transform duration-700 group-hover:scale-[1.04]"
        />
      </div>
      <div className="flex flex-col flex-1 p-7 md:p-9">
        <div className="flex flex-wrap items-center gap-2 mb-5">
          <span className="overline text-white/50 border border-white/20 px-3 py-1">
            {course.level}
          </span>
          <span className="overline text-white/50 border border-white/20 px-3 py-1">
            {course.mode}
          </span>
        </div>
        <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tightest leading-tight">
          {course.name}
        </h3>
        <p className="text-white/60 mt-4 leading-relaxed flex-1">{course.description}</p>
        <div className="mt-6 flex items-center justify-between border-t border-white/10 pt-5">
          <span className="font-display text-xl font-medium">{course.price}</span>
          {course.duration && (
            <span className="overline text-white/50">{course.duration}</span>
          )}
        </div>
        <a
          href={SITE.whatsappLink}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="whitespace-nowrap mt-6 inline-flex items-center justify-center gap-2 px-6 py-3.5 text-xs font-medium uppercase tracking-[0.16em] border border-white text-white hover:bg-white hover:text-black transition-colors"
        >
          <i className="ri-whatsapp-line text-base"></i> Inscribirme
        </a>
      </div>
    </article>
  );
}

export default function CoursesSection() {
  return (
    <>
      {/* Transición */}
      <section className="relative h-[70vh] min-h-[480px] bg-black text-white overflow-hidden">
        <img
          src="https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/d6de457ff443c3e196219308e506a1b5.jpeg"
          alt="Render arquitectónico realista de interior de Casa Atalaya en San Luis Potosí"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/80"></div>
        <div className="relative z-10 h-full flex items-end px-5 md:px-10 pb-16 md:pb-24">
          <h2 className="font-display font-medium tracking-tightest text-[clamp(2.2rem,6vw,6rem)] leading-[1.02] max-w-4xl reveal">
            Antes de construirlo, podemos verlo.
          </h2>
        </div>
      </section>

      {/* Cursos */}
      <section id="cursos" className="bg-black text-white scroll-mt-20">
        <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-20 md:py-28">
          <div className="mb-14 md:mb-20 reveal">
            <p className="overline text-white/40">Cursos</p>
            <h2 className="font-display font-medium tracking-tightest text-[clamp(2rem,5vw,4.5rem)] mt-4 max-w-3xl">
              Visualización arquitectónica aplicada a proyectos reales
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {courses.map((c) => (
              <CourseCard key={c.slug} course={c} />
            ))}
          </div>

          <p className="mt-12 text-sm text-white/50 reveal">
            Los interesados se contactan por WhatsApp. Sin registro ni pagos en
            línea por el momento.
          </p>
        </div>
      </section>
    </>
  );
}